import { t } from '@transifex/native';

import { flashes } from 'pkg/actions';
import * as endpoints from 'pkg/api/endpoints/auto';
import type * as models from 'pkg/api/models';
import * as sdk from 'pkg/core/sdk';

export const deleteExercise = async (
	organizationId: number,
	id: number
): Promise<void> => {
	await sdk.destroy(endpoints.Exercises.Delete(organizationId, id));
};

export const duplicateExercise = async (
	organizationId: number,
	id: number
): Promise<models.exercise.Exercise> => {
	const response = await sdk.post(
		endpoints.Exercises.Duplicate(organizationId, id)
	);

	if (!response.ok) {
		flashes.show({
			title: t('Something went wrong!'),
			message: t('Could not duplicate exercise.'),
		});
		return;
	}

	return await response.json();
};
